import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var TimesCircle = function TimesCircle(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9893 23.3516C18.0801 23.3516 23.1074 18.3242 23.1074 12.2441C23.1074 6.16406 18.0693 1.13672 11.9785 1.13672C5.89844 1.13672 0.881836 6.16406 0.881836 12.2441C0.881836 18.3242 5.90918 23.3516 11.9893 23.3516ZM8.32617 16.9277C7.75684 16.9277 7.30566 16.4766 7.30566 15.8965C7.30566 15.6387 7.41309 15.3809 7.61719 15.1875L10.5391 12.2549L7.61719 9.33301C7.41309 9.13965 7.30566 8.88184 7.30566 8.62402C7.30566 8.04395 7.75684 7.60352 8.32617 7.60352C8.62695 7.60352 8.86328 7.7002 9.05664 7.89355L11.9893 10.8154L14.9326 7.88281C15.1475 7.67871 15.373 7.58203 15.6631 7.58203C16.2324 7.58203 16.6836 8.0332 16.6836 8.60254C16.6836 8.87109 16.5762 9.10742 16.3721 9.32227L13.4502 12.2549L16.3721 15.1768C16.5654 15.3809 16.6729 15.6279 16.6729 15.8965C16.6729 16.4766 16.2217 16.9277 15.6416 16.9277C15.3516 16.9277 15.1045 16.8203 14.9004 16.627L11.9893 13.7158L9.07812 16.627C8.88477 16.8311 8.62695 16.9277 8.32617 16.9277Z"
  }));
};

TimesCircle.displayName = 'TimesCircle';
export default TimesCircle;